/* @ts-self-types="./poseref_wasm.d.ts" */

export class AdjacencyResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AdjacencyResult.prototype);
        obj.__wbg_ptr = ptr;
        AdjacencyResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AdjacencyResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_adjacencyresult_free(ptr, 0);
    }
    /**
     * @returns {Uint32Array}
     */
    get data() {
        const ret = wasm.adjacencyresult_data(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get offsets() {
        const ret = wasm.adjacencyresult_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) AdjacencyResult.prototype[Symbol.dispose] = AdjacencyResult.prototype.free;

export class CurveEvalResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CurveEvalResult.prototype);
        obj.__wbg_ptr = ptr;
        CurveEvalResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CurveEvalResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_curveevalresult_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    get frames() {
        const ret = wasm.curveevalresult_frames(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get positions() {
        const ret = wasm.curveevalresult_positions(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get radii() {
        const ret = wasm.curveevalresult_radii(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get tilts() {
        const ret = wasm.curveevalresult_tilts(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) CurveEvalResult.prototype[Symbol.dispose] = CurveEvalResult.prototype.free;

export class FaceGrid {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FaceGridFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_facegrid_free(ptr, 0);
    }
    /**
     * @param {Float32Array} positions
     * @param {Uint32Array} indices
     */
    constructor(positions, indices) {
        const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray32ToWasm0(indices, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.facegrid_new(ptr0, len0, ptr1, len1);
        this.__wbg_ptr = ret >>> 0;
        FaceGridFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Returns packed [x, y, z, nx, ny, nz, distSq], or empty Vec when no hit.
     * @param {number} px
     * @param {number} py
     * @param {number} pz
     * @returns {Float32Array}
     */
    query_nearest_surface(px, py, pz) {
        const ret = wasm.facegrid_query_nearest_surface(this.__wbg_ptr, px, py, pz);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) FaceGrid.prototype[Symbol.dispose] = FaceGrid.prototype.free;

export class FramesResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FramesResult.prototype);
        obj.__wbg_ptr = ptr;
        FramesResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FramesResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_framesresult_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    get frames() {
        const ret = wasm.framesresult_frames(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) FramesResult.prototype[Symbol.dispose] = FramesResult.prototype.free;

/**
 * Result of an IK solve.
 */
export class IKResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(IKResult.prototype);
        obj.__wbg_ptr = ptr;
        IKResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IKResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ikresult_free(ptr, 0);
    }
    /**
     * @returns {Float64Array}
     */
    get bone_poses() {
        const ret = wasm.ikresult_bone_poses(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get corrective_weights() {
        const ret = wasm.ikresult_corrective_weights(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    get is_violating() {
        const ret = wasm.ikresult_is_violating(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Float64Array}
     */
    get secondary_poses() {
        const ret = wasm.ikresult_secondary_poses(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {Float64Array}
     */
    get violation_pos() {
        const ret = wasm.ikresult_violation_pos(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
}
if (Symbol.dispose) IKResult.prototype[Symbol.dispose] = IKResult.prototype.free;

/**
 * Packed feature map returned by `inking_run_features`. Callers hand this
 * buffer back into `inking_run_strokes` along with the original G-buffer
 * fragments needed for tracing / styling; the worker never has to unpack it.
 */
export class InkingFeatureMapPacked {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(InkingFeatureMapPacked.prototype);
        obj.__wbg_ptr = ptr;
        InkingFeatureMapPackedFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InkingFeatureMapPackedFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_inkingfeaturemappacked_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    get confidence() {
        const ret = wasm.inkingfeaturemappacked_confidence(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    get feature_pixels() {
        const ret = wasm.inkingfeaturemappacked_feature_pixels(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Uint8Array}
     */
    get feature_type() {
        const ret = wasm.inkingfeaturemappacked_feature_type(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint8Array}
     */
    get silhouette_kind() {
        const ret = wasm.inkingfeaturemappacked_silhouette_kind(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get silhouette_neighbor_id() {
        const ret = wasm.inkingfeaturemappacked_silhouette_neighbor_id(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get silhouette_object_id() {
        const ret = wasm.inkingfeaturemappacked_silhouette_object_id(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) InkingFeatureMapPacked.prototype[Symbol.dispose] = InkingFeatureMapPacked.prototype.free;

/**
 * The packed pipeline result. TS unpacks `stroke_offsets` / `stroke_meta` and
 * slices `samples` / `thickness` / `opacity` into per-stroke views.
 *
 * Layout:
 *   - `samples`, `thickness`, `opacity` — concatenated across all strokes.
 *   - `stroke_offsets` — length `strokeCount + 1`, giving the SAMPLE-COUNT
 *     prefix sum. Stroke `k` owns samples `[offsets[k], offsets[k+1])`.
 *   - `stroke_meta` — 7 floats per stroke:
 *     `[featureType, confidence, mix0, mix1, mix2, resolvedAutoSmoothAngle, closed]`
 *     (`closed` is `0.0` or `1.0`).
 */
export class InkingPipelineResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(InkingPipelineResult.prototype);
        obj.__wbg_ptr = ptr;
        InkingPipelineResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InkingPipelineResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_inkingpipelineresult_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get chain_count() {
        const ret = wasm.inkingpipelineresult_chain_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get curve_count() {
        const ret = wasm.inkingpipelineresult_curve_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get feature_pixels() {
        const ret = wasm.inkingpipelineresult_feature_pixels(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    get opacity() {
        const ret = wasm.inkingpipelineresult_opacity(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get samples() {
        const ret = wasm.inkingpipelineresult_samples(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    get stroke_count() {
        const ret = wasm.inkingpipelineresult_stroke_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    get stroke_meta() {
        const ret = wasm.inkingpipelineresult_stroke_meta(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get stroke_offsets() {
        const ret = wasm.inkingpipelineresult_stroke_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get thickness() {
        const ret = wasm.inkingpipelineresult_thickness(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) InkingPipelineResult.prototype[Symbol.dispose] = InkingPipelineResult.prototype.free;

/**
 * Packed stroke-graph result. TS unpacks `chain_offsets` + `chain_meta` and
 * slices `points` into per-chain interleaved coordinate views.
 *
 * Layout:
 *   - `points` — concatenated `[x0, y0, x1, y1, ...]` across all chains.
 *   - `chain_offsets` — length `chain_count + 1`, giving the POINT-COUNT
 *     prefix sum. Chain `k` owns `points[offsets[k]*2 .. offsets[k+1]*2]`.
 *   - `chain_meta` — 6 floats per chain:
 *     `[featureType, confidence, mix0, mix1, mix2, resolvedAutoSmoothAngle]`.
 */
export class InkingStrokeGraphResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(InkingStrokeGraphResult.prototype);
        obj.__wbg_ptr = ptr;
        InkingStrokeGraphResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InkingStrokeGraphResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_inkingstrokegraphresult_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get chain_count() {
        const ret = wasm.inkingstrokegraphresult_chain_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    get chain_meta() {
        const ret = wasm.inkingstrokegraphresult_chain_meta(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get chain_offsets() {
        const ret = wasm.inkingstrokegraphresult_chain_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get points() {
        const ret = wasm.inkingstrokegraphresult_points(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) InkingStrokeGraphResult.prototype[Symbol.dispose] = InkingStrokeGraphResult.prototype.free;

export class LoopNormalsResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LoopNormalsResult.prototype);
        obj.__wbg_ptr = ptr;
        LoopNormalsResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LoopNormalsResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_loopnormalsresult_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    get normals() {
        const ret = wasm.loopnormalsresult_normals(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) LoopNormalsResult.prototype[Symbol.dispose] = LoopNormalsResult.prototype.free;

/**
 * Result of shared-vertex mesh extraction.
 *
 * Outputs shared vertex positions (no UV splitting), polygon topology,
 * per-loop normals, per-loop UVs, and render-space triangle indices.
 */
export class MeshExtractorResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MeshExtractorResult.prototype);
        obj.__wbg_ptr = ptr;
        MeshExtractorResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MeshExtractorResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_meshextractorresult_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    get loop_normals() {
        const ret = wasm.meshextractorresult_loop_normals(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get material_group_counts() {
        const ret = wasm.meshextractorresult_material_group_counts(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get material_group_mat_indices() {
        const ret = wasm.meshextractorresult_material_group_mat_indices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get material_group_starts() {
        const ret = wasm.meshextractorresult_material_group_starts(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get positions() {
        const ret = wasm.meshextractorresult_positions(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get render_indices() {
        const ret = wasm.meshextractorresult_render_indices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get topo_corners() {
        const ret = wasm.meshextractorresult_topo_corners(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get topo_offsets() {
        const ret = wasm.meshextractorresult_topo_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get uvs() {
        const ret = wasm.meshextractorresult_uvs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) MeshExtractorResult.prototype[Symbol.dispose] = MeshExtractorResult.prototype.free;

/**
 * Returned by `recompute_loop_normals_partial` — the inclusive corner-index
 * range `[min_dirty_corner, max_dirty_corner]` of every loop-normal slot that
 * was zeroed and recomputed during the call.  The caller uses this to bound a
 * `BufferAttribute.addUpdateRange` GPU upload instead of re-uploading the
 * full normal buffer.
 *
 * When no corners were touched (empty affected set), `min_dirty_corner` is
 * `u32::MAX` and `max_dirty_corner` is `0`.
 */
export class NormalsPartialResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NormalsPartialResult.prototype);
        obj.__wbg_ptr = ptr;
        NormalsPartialResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NormalsPartialResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_normalspartialresult_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get max_dirty_corner() {
        const ret = wasm.normalspartialresult_max_dirty_corner(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get min_dirty_corner() {
        const ret = wasm.normalspartialresult_min_dirty_corner(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) NormalsPartialResult.prototype[Symbol.dispose] = NormalsPartialResult.prototype.free;

export class ProportionalWeightsResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ProportionalWeightsResult.prototype);
        obj.__wbg_ptr = ptr;
        ProportionalWeightsResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ProportionalWeightsResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_proportionalweightsresult_free(ptr, 0);
    }
    /**
     * @returns {Uint32Array}
     */
    get indices() {
        const ret = wasm.proportionalweightsresult_indices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get weights() {
        const ret = wasm.proportionalweightsresult_weights(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) ProportionalWeightsResult.prototype[Symbol.dispose] = ProportionalWeightsResult.prototype.free;

export class SettleResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SettleResult.prototype);
        obj.__wbg_ptr = ptr;
        SettleResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SettleResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_settleresult_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get max_edge_deviation() {
        const ret = wasm.settleresult_max_edge_deviation(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get substeps_run() {
        const ret = wasm.settleresult_substeps_run(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float64Array}
     */
    get trajectory() {
        const ret = wasm.settleresult_trajectory(this.__wbg_ptr);
        var v1 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
        return v1;
    }
    /**
     * @returns {number}
     */
    get trajectory_frame_count() {
        const ret = wasm.settleresult_trajectory_frame_count(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) SettleResult.prototype[Symbol.dispose] = SettleResult.prototype.free;

export class SkinMeshResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SkinMeshResult.prototype);
        obj.__wbg_ptr = ptr;
        SkinMeshResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SkinMeshResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_skinmeshresult_free(ptr, 0);
    }
    /**
     * @returns {Uint32Array}
     */
    get indices() {
        const ret = wasm.skinmeshresult_indices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get normals() {
        const ret = wasm.skinmeshresult_normals(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get positions() {
        const ret = wasm.skinmeshresult_positions(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Int32Array}
     */
    get source_verts() {
        const ret = wasm.skinmeshresult_source_verts(this.__wbg_ptr);
        var v1 = getArrayI32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) SkinMeshResult.prototype[Symbol.dispose] = SkinMeshResult.prototype.free;

export class SpatialGrid {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SpatialGrid.prototype);
        obj.__wbg_ptr = ptr;
        SpatialGridFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SpatialGridFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_spatialgrid_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get cell_size() {
        const ret = wasm.spatialgrid_cell_size(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get max_patch_extent() {
        const ret = wasm.spatialgrid_max_patch_extent(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get point_count() {
        const ret = wasm.spatialgrid_point_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Return indices of all points within `radius` of `(cx, cy, cz)`.
     * Allocates a fresh `Vec<u32>` per call; the wasm-bindgen glue copies
     * once into a JS-owned `Uint32Array`.
     * @param {number} cx
     * @param {number} cy
     * @param {number} cz
     * @param {number} radius
     * @returns {Uint32Array}
     */
    query_radius(cx, cy, cz, radius) {
        const ret = wasm.spatialgrid_query_radius(this.__wbg_ptr, cx, cy, cz, radius);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Change cell size and rebuild, but only if the change is significant.
     * Within 20% the existing buckets still work (distance filter still
     * correct), so we skip the O(n) rebuild.
     * @param {number} cell_size
     */
    set_cell_size(cell_size) {
        wasm.spatialgrid_set_cell_size(this.__wbg_ptr, cell_size);
    }
    /**
     * Swap-remove the given indices from their current buckets and
     * re-insert them using the positions in `new_positions` (which is the
     * caller's live vertex buffer; we copy just the moved points into our
     * owned storage). No-op for indices ≥ point_count.
     * @param {Uint32Array} indices
     * @param {Float32Array} new_positions
     */
    update_points(indices, new_positions) {
        const ptr0 = passArray32ToWasm0(indices, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayF32ToWasm0(new_positions, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.spatialgrid_update_points(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
}
if (Symbol.dispose) SpatialGrid.prototype[Symbol.dispose] = SpatialGrid.prototype.free;

export class SubdivideResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SubdivideResult.prototype);
        obj.__wbg_ptr = ptr;
        SubdivideResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SubdivideResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_subdivideresult_free(ptr, 0);
    }
    /**
     * @returns {Float32Array}
     */
    get new_point() {
        const ret = wasm.subdivideresult_new_point(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get updated_left_handle_right() {
        const ret = wasm.subdivideresult_updated_left_handle_right(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get updated_right_handle_left() {
        const ret = wasm.subdivideresult_updated_right_handle_left(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) SubdivideResult.prototype[Symbol.dispose] = SubdivideResult.prototype.free;

/**
 * Result of subdivision surface computation.
 */
export class SubsurfResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SubsurfResult.prototype);
        obj.__wbg_ptr = ptr;
        SubsurfResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SubsurfResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_subsurfresult_free(ptr, 0);
    }
    /**
     * @returns {Uint32Array}
     */
    get corners() {
        const ret = wasm.subsurfresult_corners(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get indices() {
        const ret = wasm.subsurfresult_indices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {number}
     */
    get morph_count() {
        const ret = wasm.subsurfresult_morph_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {Float32Array}
     */
    get morph_data() {
        const ret = wasm.subsurfresult_morph_data(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get normals() {
        const ret = wasm.subsurfresult_normals(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get offsets() {
        const ret = wasm.subsurfresult_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get positions() {
        const ret = wasm.subsurfresult_positions(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get sculpt_displacement() {
        const ret = wasm.subsurfresult_sculpt_displacement(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get skin_index() {
        const ret = wasm.subsurfresult_skin_index(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get skin_weight() {
        const ret = wasm.subsurfresult_skin_weight(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get uvs() {
        const ret = wasm.subsurfresult_uvs(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) SubsurfResult.prototype[Symbol.dispose] = SubsurfResult.prototype.free;

/**
 * Edge arrays built from polygon face topology.
 *
 * - `edges`: flat `[v0, v1, ...]` of all unique face edges, canonical (min,max) order.
 * - `corner_edges`: one entry per corner; `corner_edges[c]` is the index into `edges`
 *   of the edge leaving corner `c`.
 * - `edge_flags`: one byte per edge — `EDGE_BOUNDARY` (0x08) set when the edge
 *   belongs to exactly one face; all other bits clear (SHARP/SEAM are not computed here).
 */
export class TopologyEdgesResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TopologyEdgesResult.prototype);
        obj.__wbg_ptr = ptr;
        TopologyEdgesResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TopologyEdgesResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_topologyedgesresult_free(ptr, 0);
    }
    /**
     * @returns {Uint32Array}
     */
    get corner_edges() {
        const ret = wasm.topologyedgesresult_corner_edges(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint8Array}
     */
    get edge_flags() {
        const ret = wasm.topologyedgesresult_edge_flags(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get edges() {
        const ret = wasm.topologyedgesresult_edges(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) TopologyEdgesResult.prototype[Symbol.dispose] = TopologyEdgesResult.prototype.free;

/**
 * Result of a topology operation.
 *
 * In addition to the new geometry, every result carries a `vertex_provenance`
 * triple — `vertex_remap` (old → new index, -1 = removed) plus a CSR of
 * `vertex_parent_offsets` / `vertex_parents` (new → old vertices that
 * contributed). Together they let the JS reconciliation layer remap every
 * per-vertex attribute on the SceneObject (vertex groups, skin radii, sculpt
 * displacements, masks, base positions) without per-op special-casing.
 */
export class TopologyResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TopologyResult.prototype);
        obj.__wbg_ptr = ptr;
        TopologyResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TopologyResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_topologyresult_free(ptr, 0);
    }
    /**
     * @returns {Uint32Array}
     */
    get corner_edges() {
        const ret = wasm.topologyresult_corner_edges(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get corners() {
        const ret = wasm.topologyresult_corners(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint8Array}
     */
    get edge_flags() {
        const ret = wasm.topologyresult_edge_flags(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get edges() {
        const ret = wasm.topologyresult_edges(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get face_owner_vertices() {
        const ret = wasm.topologyresult_face_owner_vertices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint8Array}
     */
    get face_sources() {
        const ret = wasm.topologyresult_face_sources(this.__wbg_ptr);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get indices() {
        const ret = wasm.topologyresult_indices(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get loose_edges() {
        const ret = wasm.topologyresult_loose_edges(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get new_selected_faces() {
        const ret = wasm.topologyresult_new_selected_faces(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get new_selection() {
        const ret = wasm.topologyresult_new_selection(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get offsets() {
        const ret = wasm.topologyresult_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Float32Array}
     */
    get positions() {
        const ret = wasm.topologyresult_positions(this.__wbg_ptr);
        var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get vertex_parent_offsets() {
        const ret = wasm.topologyresult_vertex_parent_offsets(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Uint32Array}
     */
    get vertex_parents() {
        const ret = wasm.topologyresult_vertex_parents(this.__wbg_ptr);
        var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {Int32Array}
     */
    get vertex_remap() {
        const ret = wasm.topologyresult_vertex_remap(this.__wbg_ptr);
        var v1 = getArrayI32FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) TopologyResult.prototype[Symbol.dispose] = TopologyResult.prototype.free;

/**
 * Build edge arrays from polygon face topology.
 *
 * Equivalent to the TypeScript `buildEdgesAndCornerEdges` in `modeling/topology.ts`,
 * but implemented in Rust via `topology_core::build_edges_from_topology` to avoid
 * the `Map<number,number>` allocation cost at the WASM/JS boundary.
 *
 * Parameters match the PolygonTopology CSR layout:
 * - `offsets`: face start indices into `corners` (length = face_count + 1).
 * - `corners`: flat vertex indices for all face loops.
 *
 * Wire (loose) edges are excluded — pass them through `getWireEdgePairs` on
 * the TypeScript side if needed; the resulting `TopologyEdgesResult` covers
 * face edges only.
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @returns {TopologyEdgesResult}
 */
export function build_topology_edges(offsets, corners) {
    const ptr0 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.build_topology_edges(ptr0, len0, ptr1, len1);
    return TopologyEdgesResult.__wrap(ret);
}

/**
 * Build vertex → triangle adjacency in CSR format.
 * @param {Uint32Array} indices
 * @param {number} vertex_count
 * @returns {AdjacencyResult}
 */
export function build_vertex_to_faces(indices, vertex_count) {
    const ptr0 = passArray32ToWasm0(indices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.build_vertex_to_faces(ptr0, len0, vertex_count);
    return AdjacencyResult.__wrap(ret);
}

/**
 * Build vertex → polygon adjacency in CSR format.
 * @param {Uint32Array} poly_offsets
 * @param {Uint32Array} corners
 * @param {number} vertex_count
 * @returns {AdjacencyResult}
 */
export function build_vertex_to_polys(poly_offsets, corners, vertex_count) {
    const ptr0 = passArray32ToWasm0(poly_offsets, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.build_vertex_to_polys(ptr0, len0, ptr1, len1, vertex_count);
    return AdjacencyResult.__wrap(ret);
}

/**
 * Compute flat normals (no smoothing) for simple triangulated meshes.
 * Returns per-vertex normals (area-weighted accumulation).
 * @param {Float32Array} positions
 * @param {Uint32Array} indices
 * @param {number} vertex_count
 * @returns {Float32Array}
 */
export function compute_flat_normals(positions, indices, vertex_count) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(indices, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.compute_flat_normals(ptr0, len0, ptr1, len1, vertex_count);
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * Compute proportional weights for unselected vertices within `radius` of
 * any selected vertex. Output is sparse: returned `indices` contain only
 * vertices with weight > 0, and `weights` has matching length.
 *
 * `selected_indices` lists the selected vertex indices. The solver
 * internally rebuilds a boolean mask over `vertex_count` to make the
 * per-vertex "is-selected" test O(1) — the TS `Set.has()` is O(1) but
 * costs a JS function call per vertex, which dominates at interactive
 * cadence.
 * @param {Float32Array} vertices
 * @param {Uint32Array} selected_indices
 * @param {number} radius
 * @param {number} falloff_mode
 * @returns {ProportionalWeightsResult}
 */
export function compute_proportional_weights(vertices, selected_indices, radius, falloff_mode) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(selected_indices, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.compute_proportional_weights(ptr0, len0, ptr1, len1, radius, falloff_mode);
    return ProportionalWeightsResult.__wrap(ret);
}

/**
 * Compute Rotation-Minimizing Frames along an externally-supplied polyline.
 * Exposed for `skinGeometry.ts` which builds its own position + tangent
 * buffers. `positions.len()` and `tangents.len()` must both equal `n * 3`.
 * @param {Float32Array} positions
 * @param {Float32Array} tangents
 * @returns {FramesResult}
 */
export function compute_rmf_raw(positions, tangents) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(tangents, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.compute_rmf_raw(ptr0, len0, ptr1, len1);
    return FramesResult.__wrap(ret);
}

/**
 * Which normal representation is cheapest for this topology.
 * Returned as u8 for WASM compatibility: 0 = Face, 1 = Point, 2 = Corner.
 *
 * - **Face**: every edge is sharp — each corner normal equals its face normal.
 *   O(C) to compute, no smooth-group work needed.
 * - **Point**: no edges are sharp — every corner at a vertex shares one normal.
 *   O(C) to compute with simple per-vertex accumulation.
 * - **Corner**: mixed shading — the full auto-smooth path with union-find.
 *
 * Used by `recompute_loop_normals` to dispatch to the cheapest path.
 * @param {Float32Array} vertices
 * @param {Uint32Array} topo_offsets
 * @param {Uint32Array} topo_corners
 * @param {Uint8Array} edge_flags
 * @param {Uint32Array} corner_edges
 * @param {number} auto_smooth_angle
 * @returns {number}
 */
export function detect_normal_domain(vertices, topo_offsets, topo_corners, edge_flags, corner_edges, auto_smooth_angle) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(topo_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(topo_corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(edge_flags, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.detect_normal_domain(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, auto_smooth_angle);
    return ret;
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_faces
 * @param {Uint32Array} selected_edges
 * @param {number} amount
 * @param {number} segments
 * @param {number} profile
 * @param {boolean} clamp_overlap
 * @param {boolean} mark_sharp
 * @param {boolean} mark_seam
 * @param {Uint32Array} corner_edges
 * @param {Uint32Array} topo_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_bevel(positions, offsets, corners, loose_edges, selected_faces, selected_edges, amount, segments, profile, clamp_overlap, mark_sharp, mark_seam, corner_edges, topo_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_faces, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(selected_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray32ToWasm0(topo_edges, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ret = wasm.edit_bevel(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, amount, segments, profile, clamp_overlap, mark_sharp, mark_seam, ptr6, len6, ptr7, len7, ptr8, len8);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_edges
 * @param {number} twist
 * @param {boolean} reverse
 * @param {number} seed_edge_v0
 * @param {number} seed_edge_v1
 * @param {Uint32Array} corner_edges
 * @param {Uint32Array} topo_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_bridge_edge_loops(positions, offsets, corners, loose_edges, selected_edges, twist, reverse, seed_edge_v0, seed_edge_v1, corner_edges, topo_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_edges, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(topo_edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.edit_bridge_edge_loops(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, twist, reverse, seed_edge_v0, seed_edge_v1, ptr5, len5, ptr6, len6, ptr7, len7);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Float32Array} normals
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} selected
 * @returns {Float32Array}
 */
export function edit_compute_selection_normal(positions, normals, offsets, corners, selected) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.edit_compute_selection_normal(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
    var v6 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v6;
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {number} active_vertex
 * @param {Uint32Array} corner_edges
 * @param {Uint32Array} topo_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_connect_path(positions, offsets, corners, loose_edges, selected, active_vertex, corner_edges, topo_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(topo_edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.edit_connect_path(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, active_vertex, ptr5, len5, ptr6, len6, ptr7, len7);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_delete_edges(positions, offsets, corners, loose_edges, selected, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_delete_edges(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} explicit_faces
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_delete_faces(positions, offsets, corners, loose_edges, selected, explicit_faces, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(explicit_faces, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.edit_delete_faces(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_delete_only_edges_and_faces(positions, offsets, corners, loose_edges, selected, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_delete_only_edges_and_faces(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} explicit_faces
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_delete_only_faces(positions, offsets, corners, loose_edges, selected, explicit_faces, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(explicit_faces, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.edit_delete_only_faces(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_delete_vertices(positions, offsets, corners, loose_edges, selected, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_delete_vertices(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} corner_edges
 * @param {Uint32Array} edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_dissolve_edges(positions, offsets, corners, loose_edges, selected, corner_edges, edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.edit_dissolve_edges(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} explicit_faces
 * @param {Uint32Array} corner_edges
 * @param {Uint32Array} edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_dissolve_faces(positions, offsets, corners, loose_edges, selected, explicit_faces, corner_edges, edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(explicit_faces, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ret = wasm.edit_dissolve_faces(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} corner_edges
 * @param {Uint32Array} edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_dissolve_vertices(positions, offsets, corners, loose_edges, selected, corner_edges, edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.edit_dissolve_vertices(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_extrude(positions, offsets, corners, loose_edges, selected, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_extrude(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_edges
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_extrude_edges(positions, offsets, corners, loose_edges, selected_edges, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_edges, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_extrude_edges(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_faces
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_extrude_faces(positions, offsets, corners, loose_edges, selected_faces, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_faces, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_extrude_faces(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_faces
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_extrude_individual_faces(positions, offsets, corners, loose_edges, selected_faces, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_faces, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_extrude_individual_faces(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_faces
 * @param {number} dir_x
 * @param {number} dir_y
 * @param {number} dir_z
 * @param {number} distance
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_extrude_manifold(positions, offsets, corners, loose_edges, selected_faces, dir_x, dir_y, dir_z, distance, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_faces, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_extrude_manifold(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, dir_x, dir_y, dir_z, distance, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_fill_face(positions, offsets, corners, loose_edges, selected, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_fill_face(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {number} span
 * @param {number} offset
 * @param {number} seed_vertex
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_grid_fill(positions, offsets, corners, loose_edges, selected, span, offset, seed_vertex, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_grid_fill(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, span, offset, seed_vertex, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {number} v0
 * @param {number} v1
 * @param {number} t
 * @param {number} cuts
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_insert_edge_loop(positions, offsets, corners, loose_edges, v0, v1, t, cuts, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ret = wasm.edit_insert_edge_loop(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, v0, v1, t, cuts, ptr4, len4, ptr5, len5);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected_faces
 * @param {number} amount
 * @param {number} depth
 * @param {boolean} individual
 * @param {boolean} even_offset
 * @param {boolean} mark_sharp
 * @param {boolean} mark_seam
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_inset(positions, offsets, corners, loose_edges, selected_faces, amount, depth, individual, even_offset, mark_sharp, mark_seam, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected_faces, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_inset(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, amount, depth, individual, even_offset, mark_sharp, mark_seam, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {number} threshold
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_merge_by_distance(positions, offsets, corners, loose_edges, selected, threshold, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_merge_by_distance(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, threshold, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {number} strategy
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_merge_vertices(positions, offsets, corners, loose_edges, selected, strategy, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_merge_vertices(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, strategy, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {number} mouse_x
 * @param {number} mouse_y
 * @param {number} mouse_z
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_rip(positions, offsets, corners, loose_edges, selected, mouse_x, mouse_y, mouse_z, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_rip(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, mouse_x, mouse_y, mouse_z, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {number} iterations
 * @param {number} factor
 * @param {number} axis_mask
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_smooth(positions, offsets, corners, loose_edges, selected, iterations, factor, axis_mask, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_smooth(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, iterations, factor, axis_mask, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Uint32Array} loose_edges
 * @param {Uint32Array} selected
 * @param {Uint32Array} old_edges
 * @param {Uint8Array} old_edge_flags
 * @returns {TopologyResult | undefined}
 */
export function edit_subdivide(positions, offsets, corners, loose_edges, selected, old_edges, old_edge_flags) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(loose_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(selected, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(old_edges, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray8ToWasm0(old_edge_flags, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.edit_subdivide(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6);
    return ret === 0 ? undefined : TopologyResult.__wrap(ret);
}

/**
 * Enforce handle constraints for each point in `changed_indices`.
 * `changed_components[i]` encodes which component moved (`MOVED_CO` = 0,
 * `MOVED_LEFT` = 1, `MOVED_RIGHT` = 2, `MOVED_UNKNOWN` = 0xFF treated as co).
 * @param {Float32Array} points
 * @param {Uint8Array} handle_types
 * @param {Uint32Array} changed_indices
 * @param {Uint8Array} changed_components
 * @param {boolean} cyclic
 */
export function enforce_handle_constraints_batch(points, handle_types, changed_indices, changed_components, cyclic) {
    var ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(handle_types, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(changed_indices, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(changed_components, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    wasm.enforce_handle_constraints_batch(ptr0, len0, points, ptr1, len1, ptr2, len2, ptr3, len3, cyclic);
}

/**
 * Exposed for TS callers that want a single-sample Bezier evaluation.
 * @param {number} p0x
 * @param {number} p0y
 * @param {number} p0z
 * @param {number} h0x
 * @param {number} h0y
 * @param {number} h0z
 * @param {number} h1x
 * @param {number} h1y
 * @param {number} h1z
 * @param {number} p1x
 * @param {number} p1y
 * @param {number} p1z
 * @param {number} t
 * @returns {Float32Array}
 */
export function eval_bezier_segment(p0x, p0y, p0z, h0x, h0y, h0z, h1x, h1y, h1z, p1x, p1y, p1z, t) {
    const ret = wasm.eval_bezier_segment(p0x, p0y, p0z, h0x, h0y, h0z, h1x, h1y, h1z, p1x, p1y, p1z, t);
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Exposed for TS callers that want a single-sample Bezier tangent.
 * @param {number} p0x
 * @param {number} p0y
 * @param {number} p0z
 * @param {number} h0x
 * @param {number} h0y
 * @param {number} h0z
 * @param {number} h1x
 * @param {number} h1y
 * @param {number} h1z
 * @param {number} p1x
 * @param {number} p1y
 * @param {number} p1z
 * @param {number} t
 * @returns {Float32Array}
 */
export function eval_bezier_tangent(p0x, p0y, p0z, h0x, h0y, h0z, h1x, h1y, h1z, p1x, p1y, p1z, t) {
    const ret = wasm.eval_bezier_tangent(p0x, p0y, p0z, h0x, h0y, h0z, h1x, h1y, h1z, p1x, p1y, p1z, t);
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * Evaluate a full curve at `resolution_u` steps per Bezier segment.
 *
 * The sampling pattern exactly matches the TS implementation:
 * - `segCount = cyclic ? n : n-1`
 * - Each segment emits `resolution_u` samples; the final segment emits
 *   `resolution_u + 1` (to include the endpoint).
 * - Sample `step == 0` on segments after the first is skipped to avoid
 *   duplicating the previous segment's endpoint.
 * @param {Float32Array} points
 * @param {number} resolution_u
 * @param {boolean} cyclic
 * @returns {CurveEvalResult}
 */
export function evaluate_curve(points, resolution_u, cyclic) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.evaluate_curve(ptr0, len0, resolution_u, cyclic);
    return CurveEvalResult.__wrap(ret);
}

/**
 * Extract shared-vertex mesh from Blender binary data.
 *
 * Positions remain at original vertex count (no UV splitting).
 * Topology corners reference shared vertex indices.
 * UVs and normals are per-loop (per face-corner).
 * Render indices reference corner positions for expanded GPU arrays.
 * @param {Int32Array} face_offsets
 * @param {Int32Array} corner_verts
 * @param {Float32Array} positions
 * @param {Float32Array} per_loop_uvs
 * @param {Int32Array} face_material_indices
 * @param {number} totpoly
 * @param {number} totloop
 * @param {number} auto_smooth_angle
 * @returns {MeshExtractorResult}
 */
export function extract_shared_mesh(face_offsets, corner_verts, positions, per_loop_uvs, face_material_indices, totpoly, totloop, auto_smooth_angle) {
    const ptr0 = passArray32ToWasm0(face_offsets, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(corner_verts, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(per_loop_uvs, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(face_material_indices, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.extract_shared_mesh(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, totpoly, totloop, auto_smooth_angle);
    return MeshExtractorResult.__wrap(ret);
}

/**
 * Generate the skin mesh for the provided wire graph. See the TypeScript
 * wrapper at `apps/web/src/wasm/skinGeometry.ts` for the argument
 * meanings; `style` and `cap_style` accept the numeric codes listed at the
 * top of this file.
 * @param {Float32Array} positions
 * @param {Uint32Array} edges
 * @param {Float32Array} radii
 * @param {number} subdivisions
 * @param {number} cap_style
 * @param {boolean} preserve_volume
 * @param {number} style
 * @param {number} strand_count_raw
 * @param {number} twist_rate
 * @param {number} bundle_jitter
 * @param {number} rib_frequency
 * @param {number} rib_depth
 * @param {number} link_length
 * @param {number} link_aspect
 * @param {number} wire_thickness
 * @param {number} link_overlap
 * @param {number} twist_per_link
 * @param {number} link_segments_raw
 * @returns {SkinMeshResult}
 */
export function generate_skin_mesh(positions, edges, radii, subdivisions, cap_style, preserve_volume, style, strand_count_raw, twist_rate, bundle_jitter, rib_frequency, rib_depth, link_length, link_aspect, wire_thickness, link_overlap, twist_per_link, link_segments_raw) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(radii, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.generate_skin_mesh(ptr0, len0, ptr1, len1, ptr2, len2, subdivisions, cap_style, preserve_volume, style, strand_count_raw, twist_rate, bundle_jitter, rib_frequency, rib_depth, link_length, link_aspect, wire_thickness, link_overlap, twist_per_link, link_segments_raw);
    return SkinMeshResult.__wrap(ret);
}

export function ik_create_session() {
    wasm.ik_create_session();
}

export function ik_destroy_session() {
    wasm.ik_destroy_session();
}

/**
 * Initialize the IK system with rest poses, bone names, and constraint data.
 *
 * - `rest_quats`: flat f64 array [qx,qy,qz,qw, qx,qy,qz,qw, ...]
 * - `bone_names`: null-separated UTF-8 bone names
 * - `constraint_json`: JSON-encoded constraint overrides (or empty)
 * - `morph_names`: null-separated UTF-8 morph target names (for corrective discovery)
 * @param {Float64Array} rest_quats
 * @param {Uint8Array} bone_names
 * @param {Uint8Array} constraint_json
 * @param {Uint8Array} morph_names
 */
export function ik_init(rest_quats, bone_names, constraint_json, morph_names) {
    const ptr0 = passArrayF64ToWasm0(rest_quats, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(bone_names, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(constraint_json, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(morph_names, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    wasm.ik_init(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
}

/**
 * Solve a single IK chain (analytical or Jacobian).
 *
 * - `chain_data`: flat f64 array encoding the chain
 *   [bone_count, then per-bone: pos_x, pos_y, pos_z, len, start_qx, start_qy, start_qz, start_qw,
 *    parent_qx, parent_qy, parent_qz, parent_qw, bone_name_idx]
 *   Plus one extra position (the tip): [tip_x, tip_y, tip_z]
 * - `target`: [x, y, z]
 * - `solver_type`: 0 = analytical, 1 = jacobian
 * - `options`: flat f64 array [constraint_weight, exclude_last_bone(0/1), has_session(0/1), is_first_frame(0/1),
 *   has_pole(0/1), pole_x, pole_y, pole_z, has_view_bias(0/1), vb_fwd_x, vb_fwd_y, vb_fwd_z, vb_orig_depth, vb_strength,
 *   active_bone_idx]
 * - `current_poses`: flat f64 array [bone_idx, qx, qy, qz, qw, ...]
 * @param {Float64Array} chain_data
 * @param {Float64Array} target
 * @param {number} solver_type
 * @param {Float64Array} options
 * @param {Float64Array} current_poses
 * @returns {IKResult}
 */
export function ik_solve_chain(chain_data, target, solver_type, options, current_poses) {
    const ptr0 = passArrayF64ToWasm0(chain_data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF64ToWasm0(target, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF64ToWasm0(options, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF64ToWasm0(current_poses, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.ik_solve_chain(ptr0, len0, ptr1, len1, solver_type, ptr2, len2, ptr3, len3);
    return IKResult.__wrap(ret);
}

/**
 * Compute corrective weights and secondary motion for current poses (FK only).
 * @param {Float64Array} current_poses
 * @returns {IKResult}
 */
export function ik_solve_fk(current_poses) {
    const ptr0 = passArrayF64ToWasm0(current_poses, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.ik_solve_fk(ptr0, len0);
    return IKResult.__wrap(ret);
}

/**
 * Solve whole-body IK with multiple targets.
 *
 * - `skeleton_data`: flat f64 array [bone_count, then per-bone: local_qx..qw, offset_x,y,z, bone_name_idx]
 * - `parent_idx`: per-bone parent index (-1 = root)
 * - `root_data`: [root_x, root_y, root_z, root_parent_qx, qy, qz, qw]
 * - `targets`: flat f64 array [target_count, then per-target: bone_name_idx, pos_x, pos_y, pos_z, weight]
 * - `options`: [constraint_weight, has_session(0/1), is_first_frame(0/1), locked_bone_count, locked_idx0, ..., active_bone_idx]
 * - `current_poses`: flat f64 array [bone_idx, qx, qy, qz, qw, ...]
 * @param {Float64Array} skeleton_data
 * @param {Int32Array} parent_idx
 * @param {Float64Array} root_data
 * @param {Float64Array} targets
 * @param {Float64Array} options
 * @param {Float64Array} current_poses
 * @returns {IKResult}
 */
export function ik_solve_whole_body(skeleton_data, parent_idx, root_data, targets, options, current_poses) {
    const ptr0 = passArrayF64ToWasm0(skeleton_data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(parent_idx, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF64ToWasm0(root_data, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF64ToWasm0(targets, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArrayF64ToWasm0(options, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF64ToWasm0(current_poses, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ret = wasm.ik_solve_whole_body(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
    return IKResult.__wrap(ret);
}

/**
 * @param {Uint8Array} json
 */
export function ik_update_overrides(json) {
    const ptr0 = passArray8ToWasm0(json, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.ik_update_overrides(ptr0, len0);
}

/**
 * @param {Float32Array} points
 * @param {number} sigma_min
 * @param {number} sigma_max
 * @param {number} curvature_threshold
 * @param {boolean} closed
 * @param {number} corner_angle_deg
 * @returns {Float32Array}
 */
export function inking_adaptive_smooth_polyline(points, sigma_min, sigma_max, curvature_threshold, closed, corner_angle_deg) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_adaptive_smooth_polyline(ptr0, len0, sigma_min, sigma_max, curvature_threshold, closed, corner_angle_deg);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Uint8Array} skeleton
 * @param {Float32Array} confidence
 * @param {Uint8Array} feature_type
 * @param {Float32Array} resolved_auto_smooth_angles
 * @param {number} min_chain_length
 * @param {number} corner_angle_deg
 * @returns {InkingStrokeGraphResult}
 */
export function inking_build_stroke_graph(width, height, skeleton, confidence, feature_type, resolved_auto_smooth_angles, min_chain_length, corner_angle_deg) {
    const ptr0 = passArray8ToWasm0(skeleton, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(feature_type, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(resolved_auto_smooth_angles, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.inking_build_stroke_graph(width, height, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, min_chain_length, corner_angle_deg);
    return InkingStrokeGraphResult.__wrap(ret);
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} luminance
 * @param {Float32Array} params
 * @returns {Float32Array}
 */
export function inking_compute_deep_shadow_mask(width, height, depth, luminance, params) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(luminance, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.inking_compute_deep_shadow_mask(width, height, ptr0, len0, ptr1, len1, ptr2, len2);
    var v4 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v4;
}

/**
 * @param {Float32Array} samples
 * @param {number} feature_type
 * @param {number} confidence
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} luminance
 * @param {Float32Array} params
 * @returns {Float32Array}
 */
export function inking_compute_opacity(samples, feature_type, confidence, width, height, depth, luminance, params) {
    const ptr0 = passArrayF32ToWasm0(samples, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(luminance, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.inking_compute_opacity(ptr0, len0, feature_type, confidence, width, height, ptr1, len1, ptr2, len2, ptr3, len3);
    var v5 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v5;
}

/**
 * @param {Float32Array} samples
 * @param {number} feature_type
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} luminance
 * @param {Float32Array} params
 * @param {boolean} closed
 * @returns {Float32Array}
 */
export function inking_compute_thickness(samples, feature_type, width, height, depth, luminance, params, closed) {
    const ptr0 = passArrayF32ToWasm0(samples, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(luminance, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.inking_compute_thickness(ptr0, len0, feature_type, width, height, ptr1, len1, ptr2, len2, ptr3, len3, closed);
    var v5 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v5;
}

/**
 * @param {Float32Array} points
 * @param {number} corner_angle_deg
 * @param {boolean} closed
 * @returns {Uint8Array}
 */
export function inking_detect_corner_mask(points, corner_angle_deg, closed) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_detect_corner_mask(ptr0, len0, corner_angle_deg, closed);
    var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v2;
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} normals
 * @param {Uint32Array} object_ids
 * @param {number} crease_angle
 * @param {Float32Array} confidence
 * @param {Uint8Array} feature_type
 * @param {Uint32Array} silhouette_object_id
 * @param {Uint32Array} silhouette_neighbor_id
 * @param {Uint8Array} silhouette_kind
 */
export function inking_extract_creases(width, height, depth, normals, object_ids, crease_angle, confidence, feature_type, silhouette_object_id, silhouette_neighbor_id, silhouette_kind) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    var len3 = WASM_VECTOR_LEN;
    var ptr4 = passArray8ToWasm0(feature_type, wasm.__wbindgen_malloc);
    var len4 = WASM_VECTOR_LEN;
    var ptr5 = passArray32ToWasm0(silhouette_object_id, wasm.__wbindgen_malloc);
    var len5 = WASM_VECTOR_LEN;
    var ptr6 = passArray32ToWasm0(silhouette_neighbor_id, wasm.__wbindgen_malloc);
    var len6 = WASM_VECTOR_LEN;
    var ptr7 = passArray8ToWasm0(silhouette_kind, wasm.__wbindgen_malloc);
    var len7 = WASM_VECTOR_LEN;
    wasm.inking_extract_creases(width, height, ptr0, len0, ptr1, len1, ptr2, len2, crease_angle, ptr3, len3, confidence, ptr4, len4, feature_type, ptr5, len5, silhouette_object_id, ptr6, len6, silhouette_neighbor_id, ptr7, len7, silhouette_kind);
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} normals
 * @param {Uint32Array} object_ids
 * @param {number} detail
 * @param {Float32Array} confidence
 * @param {Uint8Array} feature_type
 * @param {Uint32Array} silhouette_object_id
 * @param {Uint32Array} silhouette_neighbor_id
 * @param {Uint8Array} silhouette_kind
 */
export function inking_extract_screen_edges(width, height, depth, normals, object_ids, detail, confidence, feature_type, silhouette_object_id, silhouette_neighbor_id, silhouette_kind) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    var len3 = WASM_VECTOR_LEN;
    var ptr4 = passArray8ToWasm0(feature_type, wasm.__wbindgen_malloc);
    var len4 = WASM_VECTOR_LEN;
    var ptr5 = passArray32ToWasm0(silhouette_object_id, wasm.__wbindgen_malloc);
    var len5 = WASM_VECTOR_LEN;
    var ptr6 = passArray32ToWasm0(silhouette_neighbor_id, wasm.__wbindgen_malloc);
    var len6 = WASM_VECTOR_LEN;
    var ptr7 = passArray8ToWasm0(silhouette_kind, wasm.__wbindgen_malloc);
    var len7 = WASM_VECTOR_LEN;
    wasm.inking_extract_screen_edges(width, height, ptr0, len0, ptr1, len1, ptr2, len2, detail, ptr3, len3, confidence, ptr4, len4, feature_type, ptr5, len5, silhouette_object_id, ptr6, len6, silhouette_neighbor_id, ptr7, len7, silhouette_kind);
}

/**
 * Run the silhouette detector, writing into caller-provided feature buffers.
 *
 * All feature-buffer slices must be `width × height` long.
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Uint32Array} object_ids
 * @param {Float32Array} normals
 * @param {Float32Array} confidence
 * @param {Uint8Array} feature_type
 * @param {Uint32Array} silhouette_object_id
 * @param {Uint32Array} silhouette_neighbor_id
 * @param {Uint8Array} silhouette_kind
 */
export function inking_extract_silhouettes(width, height, depth, object_ids, normals, confidence, feature_type, silhouette_object_id, silhouette_neighbor_id, silhouette_kind) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(normals, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    var ptr3 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    var len3 = WASM_VECTOR_LEN;
    var ptr4 = passArray8ToWasm0(feature_type, wasm.__wbindgen_malloc);
    var len4 = WASM_VECTOR_LEN;
    var ptr5 = passArray32ToWasm0(silhouette_object_id, wasm.__wbindgen_malloc);
    var len5 = WASM_VECTOR_LEN;
    var ptr6 = passArray32ToWasm0(silhouette_neighbor_id, wasm.__wbindgen_malloc);
    var len6 = WASM_VECTOR_LEN;
    var ptr7 = passArray8ToWasm0(silhouette_kind, wasm.__wbindgen_malloc);
    var len7 = WASM_VECTOR_LEN;
    wasm.inking_extract_silhouettes(width, height, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, confidence, ptr4, len4, feature_type, ptr5, len5, silhouette_object_id, ptr6, len6, silhouette_neighbor_id, ptr7, len7, silhouette_kind);
}

/**
 * Fit cubic Bézier segments (Schneider 1990) to a polyline.
 *
 * Returns a flat `f64` buffer of concatenated control points — 8 floats per
 * segment: `p0x, p0y, cp1x, cp1y, cp2x, cp2y, p1x, p1y`. An empty buffer
 * means the chain was too short to fit.
 * @param {Float32Array} points
 * @param {number} tolerance
 * @returns {Float64Array}
 */
export function inking_fit_polyline(points, tolerance) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_fit_polyline(ptr0, len0, tolerance);
    var v2 = getArrayF64FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
    return v2;
}

/**
 * Returns the profile as a flat 7-element `[f32]` array to avoid a struct
 * getter allocation round-trip. Order matches `StrokeSmoothingProfile`:
 *   `[sigma_min, sigma_max, curvature_threshold, corner_angle_deg,
 *     thickness_smoothing_radius, boundary_smoothing_radius,
 *     corner_protection_radius]`.
 *
 * `bbox_diag_px` is the bounding-box diagonal of the chain's polyline in
 * pixels and drives the scale-aware σ ramp.
 * @param {number} feature_type
 * @param {number} resolved_auto_smooth_angle
 * @param {number} bbox_diag_px
 * @returns {Float32Array}
 */
export function inking_get_stroke_smoothing_profile(feature_type, resolved_auto_smooth_angle, bbox_diag_px) {
    const ret = wasm.inking_get_stroke_smoothing_profile(feature_type, resolved_auto_smooth_angle, bbox_diag_px);
    var v1 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {number} width
 * @param {number} _height
 * @param {Uint32Array} silhouette_object_id
 * @param {Uint32Array} silhouette_neighbor_id
 * @param {Float32Array} depth
 * @param {number} a
 * @param {number} b
 * @returns {boolean}
 */
export function inking_is_same_object_silhouette_depth_compatible(width, _height, silhouette_object_id, silhouette_neighbor_id, depth, a, b) {
    const ptr0 = passArray32ToWasm0(silhouette_object_id, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(silhouette_neighbor_id, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.inking_is_same_object_silhouette_depth_compatible(width, _height, ptr0, len0, ptr1, len1, ptr2, len2, a, b);
    return ret !== 0;
}

/**
 * @param {Float32Array} points
 * @param {number} epsilon
 * @returns {Float32Array}
 */
export function inking_rdp_simplify(points, epsilon) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_rdp_simplify(ptr0, len0, epsilon);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} normals
 * @param {Uint32Array} object_ids
 * @param {Float32Array} params
 * @returns {InkingFeatureMapPacked}
 */
export function inking_run_features(width, height, depth, normals, object_ids, params) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.inking_run_features(width, height, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return InkingFeatureMapPacked.__wrap(ret);
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} normals
 * @param {Uint32Array} object_ids
 * @param {Float32Array} luminance
 * @param {Float32Array} resolved_auto_smooth_angles
 * @param {Float32Array} params
 * @returns {InkingPipelineResult}
 */
export function inking_run_pipeline(width, height, depth, normals, object_ids, luminance, resolved_auto_smooth_angles, params) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(luminance, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArrayF32ToWasm0(resolved_auto_smooth_angles, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ret = wasm.inking_run_pipeline(width, height, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
    return InkingPipelineResult.__wrap(ret);
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} depth
 * @param {Float32Array} luminance
 * @param {Float32Array} resolved_auto_smooth_angles
 * @param {Float32Array} confidence
 * @param {Uint8Array} feature_type
 * @param {Uint32Array} silhouette_object_id
 * @param {Uint32Array} silhouette_neighbor_id
 * @param {number} feature_pixels
 * @param {Float32Array} params
 * @returns {InkingPipelineResult}
 */
export function inking_run_strokes(width, height, depth, luminance, resolved_auto_smooth_angles, confidence, feature_type, silhouette_object_id, silhouette_neighbor_id, feature_pixels, params) {
    const ptr0 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(luminance, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(resolved_auto_smooth_angles, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray8ToWasm0(feature_type, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(silhouette_object_id, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(silhouette_neighbor_id, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.inking_run_strokes(width, height, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, feature_pixels, ptr7, len7);
    return InkingPipelineResult.__wrap(ret);
}

/**
 * Returns `[gx, gy, magnitude]`.
 * @param {Float32Array} values
 * @param {number} width
 * @param {number} x
 * @param {number} y
 * @returns {Float32Array}
 */
export function inking_sample_scalar_sobel(values, width, x, y) {
    const ptr0 = passArrayF32ToWasm0(values, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_sample_scalar_sobel(ptr0, len0, width, x, y);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {Float32Array} values
 * @param {Float32Array} depth
 * @param {Uint32Array} object_ids
 * @param {number} width
 * @param {number} x
 * @param {number} y
 * @returns {Float32Array}
 */
export function inking_sample_scalar_sobel_same_surface(values, depth, object_ids, width, x, y) {
    const ptr0 = passArrayF32ToWasm0(values, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.inking_sample_scalar_sobel_same_surface(ptr0, len0, ptr1, len1, ptr2, len2, width, x, y);
    var v4 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v4;
}

/**
 * @param {Float32Array} values
 * @param {number} width
 * @param {number} x
 * @param {number} y
 * @returns {number}
 */
export function inking_sample_vec3_sobel(values, width, x, y) {
    const ptr0 = passArrayF32ToWasm0(values, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_sample_vec3_sobel(ptr0, len0, width, x, y);
    return ret;
}

/**
 * @param {Float32Array} values
 * @param {Float32Array} depth
 * @param {Uint32Array} object_ids
 * @param {number} width
 * @param {number} x
 * @param {number} y
 * @returns {number}
 */
export function inking_sample_vec3_sobel_same_surface(values, depth, object_ids, width, x, y) {
    const ptr0 = passArrayF32ToWasm0(values, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(depth, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(object_ids, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.inking_sample_vec3_sobel_same_surface(ptr0, len0, ptr1, len1, ptr2, len2, width, x, y);
    return ret;
}

/**
 * Thin a confidence map to a 1px-wide binary skeleton. Returns a
 * `width × height` `Uint8Array` (`1` = skeleton, `0` = background).
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} confidence
 * @param {number} min_confidence
 * @returns {Uint8Array}
 */
export function inking_skeletonize(width, height, confidence, min_confidence) {
    const ptr0 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_skeletonize(width, height, ptr0, len0, min_confidence);
    var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v2;
}

/**
 * @param {Float32Array} points
 * @param {number} sigma
 * @param {boolean} closed
 * @returns {Float32Array}
 */
export function inking_smooth_polyline(points, sigma, closed) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_smooth_polyline(ptr0, len0, sigma, closed);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {Float32Array} points
 * @param {number} interval
 * @param {boolean} closed
 * @param {number} corner_angle_deg
 * @returns {Float32Array}
 */
export function inking_subsample_polyline(points, interval, closed, corner_angle_deg) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.inking_subsample_polyline(ptr0, len0, interval, closed, corner_angle_deg);
    var v2 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}

/**
 * @param {number} width
 * @param {number} height
 * @param {Float32Array} confidence
 * @param {Uint8Array} feature_type
 * @param {number} min_confidence
 */
export function inking_thin_feature_ridges(width, height, confidence, feature_type, min_confidence) {
    var ptr0 = passArrayF32ToWasm0(confidence, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(feature_type, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    wasm.inking_thin_feature_ridges(width, height, ptr0, len0, confidence, ptr1, len1, min_confidence);
}

/**
 * Scalar falloff — exposed so callers that only need the curve can use it
 * without packing a full vertex buffer.
 * @param {number} distance
 * @param {number} radius
 * @param {number} mode
 * @returns {number}
 */
export function proportional_falloff(distance, radius, mode) {
    const ret = wasm.proportional_falloff(distance, radius, mode);
    return ret;
}

/**
 * Compute per-loop (per face-corner) normals with auto-smooth.
 *
 * Detects the normal domain (Face/Point/Corner) and dispatches to the
 * cheapest path. Face and Point domains skip the O(V·F²) union-find.
 *
 * Returns a LoopNormalsResult with normals.length == corners.length * 3.
 * @param {Float32Array} vertices
 * @param {Uint32Array} topo_offsets
 * @param {Uint32Array} topo_corners
 * @param {number} auto_smooth_angle
 * @param {Uint8Array} edge_flags
 * @param {Uint32Array} corner_edges
 * @returns {LoopNormalsResult}
 */
export function recompute_loop_normals(vertices, topo_offsets, topo_corners, auto_smooth_angle, edge_flags, corner_edges) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(topo_offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(topo_corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray8ToWasm0(edge_flags, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(corner_edges, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.recompute_loop_normals(ptr0, len0, ptr1, len1, ptr2, len2, auto_smooth_angle, ptr3, len3, ptr4, len4);
    return LoopNormalsResult.__wrap(ret);
}

/**
 * Incrementally recompute per-loop normals for corners touching affected vertices.
 * Mutates `loop_normals` in place. Only recomputes normals for corners whose
 * vertex is in `affected_verts` or shares a face with one.
 *
 * Returns the inclusive corner-index range of every slot that was dirtied and
 * recomputed. The caller can use this to issue a tight partial GPU upload
 * instead of re-uploading the full normal buffer.
 * @param {Float32Array} vertices
 * @param {Float32Array} loop_normals
 * @param {Uint32Array} affected_verts
 * @param {Uint32Array} topo_offsets
 * @param {Uint32Array} topo_corners
 * @param {number} auto_smooth_angle
 * @returns {NormalsPartialResult}
 */
export function recompute_loop_normals_partial(vertices, loop_normals, affected_verts, topo_offsets, topo_corners, auto_smooth_angle) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = passArrayF32ToWasm0(loop_normals, wasm.__wbindgen_malloc);
    var len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(affected_verts, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(topo_offsets, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(topo_corners, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ret = wasm.recompute_loop_normals_partial(ptr0, len0, ptr1, len1, loop_normals, ptr2, len2, ptr3, len3, ptr4, len4, auto_smooth_angle);
    return NormalsPartialResult.__wrap(ret);
}

/**
 * Apply a sculpt brush dab with optional auto-smooth.
 *
 * Dispatches to the correct brush kernel based on `brush_type`, then
 * optionally applies a Laplacian smooth pass when `params[11]` (auto-smooth
 * strength) is non-zero and the brush is not already smooth/relax.
 *
 * # Parameters
 * - `brush_type`: 0=draw, 1=smooth, 2=relax, 3=flatten, 4=inflate,
 *   5=clayStrips, 6=pinch.
 * - `vertices`: `V×3` composed positions (full mesh, read-only).
 * - `vertex_normals`: `V×3` per-vertex normals (full mesh, read-only).
 * - `affected`: `N` vertex indices to process.
 * - `params`: packed `[cx,cy,cz, nx,ny,nz, radius, strength, pressure,
 *   invert(0/1), falloff_curve, auto_smooth_strength]`.
 * - `adj_vert_edge_offsets`, `adj_vert_edge_indices`, `edges`:
 *   CSR vertex→edge adjacency for smooth/relax + auto-smooth.
 * - `vertex_mask`: `V` per-vertex mask values (empty = no mask).
 *
 * # Returns
 * `N×3` displacement **deltas** — caller adds these to the active layer.
 * @param {number} brush_type
 * @param {Float32Array} vertices
 * @param {Float32Array} vertex_normals
 * @param {Uint32Array} affected
 * @param {Float32Array} params
 * @param {Uint32Array} adj_vert_edge_offsets
 * @param {Uint32Array} adj_vert_edge_indices
 * @param {Uint32Array} edges
 * @param {Float32Array} vertex_mask
 * @returns {Float32Array}
 */
export function sculpt_apply_dab(brush_type, vertices, vertex_normals, affected, params, adj_vert_edge_offsets, adj_vert_edge_indices, edges, vertex_mask) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(vertex_normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(affected, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(adj_vert_edge_offsets, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(adj_vert_edge_indices, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(vertex_mask, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_apply_dab(brush_type, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7);
    var v9 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v9;
}

/**
 * Apply N brush dabs (primary + all mirror dabs) in a single WASM call.
 *
 * Eliminates per-dab WASM boundary crossings for symmetry strokes: instead
 * of calling `sculpt_apply_dab` once per symmetry axis, the caller queries
 * the spatial grid for each dab, merges the affected vertex sets, then
 * dispatches here with all dab centres packed into one flat array.
 *
 * # Parameters
 * - `brush_type`: 0=draw, 1=smooth, 2=relax, 3=flatten, 4=inflate,
 *   5=clayStrips, 6=pinch.
 * - `vertices`: `V×3` composed positions (full mesh, read-only).
 * - `vertex_normals`: `V×3` per-vertex normals.
 * - `affected`: `N` de-duplicated vertex indices (union of all dab sets).
 * - `dab_centers_normals`: `D×6` packed dab descriptors —
 *   `[cx0,cy0,cz0,nx0,ny0,nz0, cx1,…]`.
 * - `shared_params`: `[radius, strength, pressure, invert(0/1), falloff_curve,
 *   auto_smooth]`.
 * - `adj_vert_edge_offsets`, `adj_vert_edge_indices`, `edges`: CSR adjacency.
 * - `vertex_mask`: `V` mask values (empty = no mask).
 *
 * # Returns
 * `N×3` displacement **deltas** — accumulated across all dabs.
 * @param {number} brush_type
 * @param {Float32Array} vertices
 * @param {Float32Array} vertex_normals
 * @param {Uint32Array} affected
 * @param {Float32Array} dab_centers_normals
 * @param {Float32Array} shared_params
 * @param {Uint32Array} adj_vert_edge_offsets
 * @param {Uint32Array} adj_vert_edge_indices
 * @param {Uint32Array} edges
 * @param {Float32Array} vertex_mask
 * @returns {Float32Array}
 */
export function sculpt_apply_dab_multi(brush_type, vertices, vertex_normals, affected, dab_centers_normals, shared_params, adj_vert_edge_offsets, adj_vert_edge_indices, edges, vertex_mask) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(vertex_normals, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(affected, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(dab_centers_normals, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArrayF32ToWasm0(shared_params, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArray32ToWasm0(adj_vert_edge_offsets, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(adj_vert_edge_indices, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArrayF32ToWasm0(vertex_mask, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_apply_dab_multi(brush_type, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8);
    var v10 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v10;
}

/**
 * Apply grab displacement using locked weights.
 *
 * # Returns
 * `N×3` **absolute** displacement values — caller writes them directly
 * to the active layer (not accumulated as deltas).
 * @param {Float32Array} weights
 * @param {Float32Array} initial_disp
 * @param {number} delta_x
 * @param {number} delta_y
 * @param {number} delta_z
 * @returns {Float32Array}
 */
export function sculpt_apply_grab(weights, initial_disp, delta_x, delta_y, delta_z) {
    const ptr0 = passArrayF32ToWasm0(weights, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(initial_disp, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_apply_grab(ptr0, len0, ptr1, len1, delta_x, delta_y, delta_z);
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * Mask brush — update per-vertex mask values.
 *
 * # Parameters
 * - `vertices`: `V×3` composed positions.
 * - `affected`: `N` vertex indices.
 * - `params`: packed brush params (same layout as `sculpt_apply_dab`).
 * - `current_mask`: `N` current mask values (sparse, one per affected vertex).
 *
 * # Returns
 * `N` updated mask values.
 * @param {Float32Array} vertices
 * @param {Uint32Array} affected
 * @param {Float32Array} params
 * @param {Float32Array} current_mask
 * @returns {Float32Array}
 */
export function sculpt_apply_mask(vertices, affected, params, current_mask) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(affected, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(current_mask, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_apply_mask(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    var v5 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v5;
}

/**
 * Compute per-vertex grab weights at stroke start.
 *
 * # Parameters
 * - `vertices`: `V×3` composed positions.
 * - `affected`: `N` vertex indices.
 * - `params`: packed brush params.
 * - `vertex_mask`: `V` per-vertex mask (empty = no mask).
 *
 * # Returns
 * `N` weights (one per affected vertex).
 * @param {Float32Array} vertices
 * @param {Uint32Array} affected
 * @param {Float32Array} params
 * @param {Float32Array} vertex_mask
 * @returns {Float32Array}
 */
export function sculpt_init_grab(vertices, affected, params, vertex_mask) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(affected, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(params, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(vertex_mask, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_init_grab(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    var v5 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v5;
}

/**
 * Convert per-corner (loop) normals to per-vertex normals by arithmetic mean.
 *
 * Seeds the per-vertex normal buffer used for backface culling during sculpt
 * strokes.  Matches the TypeScript `loopToVertexNormals` in `sculptOps.ts`
 * exactly: accumulate then divide by count (not normalise), preserving the
 * established contract for the sculpt pipeline.
 *
 * # Parameters
 * - `loop_normals`: `corner_count × 3` flat array — one (nx,ny,nz) per corner.
 * - `corners`: `corner_count` vertex indices — `corners[c]` is the vertex that
 *   corner `c` belongs to.
 * - `vertex_count`: number of unique vertices in the mesh.
 *
 * # Returns
 * `vertex_count × 3` flat array.
 * @param {Float32Array} loop_normals
 * @param {Uint32Array} corners
 * @param {number} vertex_count
 * @returns {Float32Array}
 */
export function sculpt_loop_to_vertex_normals(loop_normals, corners, vertex_count) {
    const ptr0 = passArrayF32ToWasm0(loop_normals, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_loop_to_vertex_normals(ptr0, len0, ptr1, len1, vertex_count);
    var v3 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v3;
}

/**
 * Full-mesh sculpt layer recomposition.
 *
 * Computes `result[i] = base[i] + Σ_l (all_displacements[l * n + i] × opacities[l])`.
 *
 * The inner loop is a stride-1 fused multiply-add over `f32` slices — the
 * compiler can auto-vectorise this into WASM SIMD with `opt-level = 3`.
 *
 * # Parameters
 * - `base`: `vertex_count × 3` flat array of unmodified base positions.
 * - `all_displacements`: `layer_count × vertex_count × 3` flat array — layer 0's
 *   displacements, then layer 1's, etc.  The caller MUST pre-filter invisible and
 *   zero-opacity layers before concatenating to avoid copying their data.
 * - `opacities`: one opacity per layer (all non-zero, all for visible layers).
 *
 * # Returns
 * `vertex_count × 3` composed position array.
 * @param {Float32Array} base
 * @param {Float32Array} all_displacements
 * @param {Float32Array} opacities
 * @returns {Float32Array}
 */
export function sculpt_recompose_full(base, all_displacements, opacities) {
    const ptr0 = passArrayF32ToWasm0(base, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayF32ToWasm0(all_displacements, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(opacities, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.sculpt_recompose_full(ptr0, len0, ptr1, len1, ptr2, len2);
    var v4 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v4;
}

/**
 * @param {boolean} on
 */
export function set_bevel_diag_enabled(on) {
    wasm.set_bevel_diag_enabled(on);
}

/**
 * Run the PBD solver. Mutates `positions` in place; returns metadata
 * (substeps, max edge deviation, optional trajectory).
 *
 * `record_stride == 0` or `record_max_frames == 0` disables trajectory
 * recording (matches the TS `recordTrajectory: undefined` path).
 * @param {Float64Array} positions
 * @param {Uint32Array} edges
 * @param {Uint8Array} pinned
 * @param {Uint32Array} bending_edges
 * @param {Uint32Array} triangles
 * @param {Float32Array} collision_tris
 * @param {Uint32Array} collision_mesh_offsets
 * @param {Float32Array} collision_aabbs
 * @param {Float64Array} params
 * @param {number} record_stride
 * @param {number} record_max_frames
 * @returns {SettleResult}
 */
export function settle_particles(positions, edges, pinned, bending_edges, triangles, collision_tris, collision_mesh_offsets, collision_aabbs, params, record_stride, record_max_frames) {
    var ptr0 = passArrayF64ToWasm0(positions, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(pinned, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(bending_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(triangles, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(collision_tris, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(collision_mesh_offsets, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(collision_aabbs, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArrayF64ToWasm0(params, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ret = wasm.settle_particles(ptr0, len0, positions, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, record_stride, record_max_frames);
    return SettleResult.__wrap(ret);
}

/**
 * Worker-facing entry point that streams progress (and honours cooperative
 * cancellation) through a JS callback. Called from `physics.worker.ts` so
 * the main thread never blocks while the solver is running.
 *
 * `progress_callback` is invoked every `progress_stride` substeps with
 * `(substep_index, max_substeps)`. Returning `false` from the callback
 * aborts the solve at the next substep boundary; the result struct
 * reflects whatever progress was made up to that point.
 *
 * `record_start_substep` shifts the trajectory window forward — useful
 * for the menu's opt-in time-range bake. `0` matches the legacy
 * behaviour (records the initial pose as frame 0 and every
 * `record_stride` substeps thereafter).
 * @param {Float64Array} positions
 * @param {Uint32Array} edges
 * @param {Uint8Array} pinned
 * @param {Uint32Array} bending_edges
 * @param {Uint32Array} triangles
 * @param {Float32Array} collision_tris
 * @param {Uint32Array} collision_mesh_offsets
 * @param {Float32Array} collision_aabbs
 * @param {Float64Array} params
 * @param {number} record_stride
 * @param {number} record_max_frames
 * @param {number} record_start_substep
 * @param {Function} progress_callback
 * @param {number} progress_stride
 * @returns {SettleResult}
 */
export function settle_particles_progress(positions, edges, pinned, bending_edges, triangles, collision_tris, collision_mesh_offsets, collision_aabbs, params, record_stride, record_max_frames, record_start_substep, progress_callback, progress_stride) {
    var ptr0 = passArrayF64ToWasm0(positions, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(edges, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(pinned, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArray32ToWasm0(bending_edges, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(triangles, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(collision_tris, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(collision_mesh_offsets, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(collision_aabbs, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArrayF64ToWasm0(params, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ret = wasm.settle_particles_progress(ptr0, len0, positions, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, record_stride, record_max_frames, record_start_substep, progress_callback, progress_stride);
    return SettleResult.__wrap(ret);
}

/**
 * One-shot shrinkwrap evaluation.
 *
 * Empty `src_normals` / `tgt_normals` / `vertex_group_indices` slices mean
 * "not provided"; the TS wrapper passes `Float32Array(0)` / `Uint32Array(0)`
 * in that case to keep the wasm-bindgen boundary simple.
 *
 * `wrap_mode`: 0 = nearest_surface, 1 = nearest_vertex, 2 = project
 * `project_axis`: 0 = x, 1 = y, 2 = z, 3 = vertex normal
 * @param {Float32Array} src_positions
 * @param {Uint32Array} src_indices
 * @param {Float32Array} src_normals
 * @param {Float32Array} tgt_positions
 * @param {Uint32Array} tgt_indices
 * @param {Float32Array} tgt_normals
 * @param {number} wrap_mode
 * @param {number} project_axis
 * @param {boolean} project_positive
 * @param {boolean} project_negative
 * @param {number} offset
 * @param {Uint32Array} vertex_group_indices
 * @returns {Float32Array}
 */
export function shrinkwrap_evaluate(src_positions, src_indices, src_normals, tgt_positions, tgt_indices, tgt_normals, wrap_mode, project_axis, project_positive, project_negative, offset, vertex_group_indices) {
    const ptr0 = passArrayF32ToWasm0(src_positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(src_indices, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArrayF32ToWasm0(src_normals, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(tgt_positions, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArray32ToWasm0(tgt_indices, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(tgt_normals, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArray32ToWasm0(vertex_group_indices, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ret = wasm.shrinkwrap_evaluate(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, wrap_mode, project_axis, project_positive, project_negative, offset, ptr6, len6);
    var v8 = getArrayF32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v8;
}

/**
 * Build a grid that indexes per-triangle centroids. For surface sketch.
 * `indices` is a flat `[a, b, c, a, b, c, …]` triangle list.
 * `cell_size` is treated as a lower bound; the effective cell size is
 * `max(cell_size, 2 * max_patch_extent)` so brush queries naturally cover
 * any triangle whose surface reaches inside the radius.
 * @param {Float32Array} vertices
 * @param {Uint32Array} indices
 * @param {number} cell_size
 * @returns {SpatialGrid}
 */
export function spatial_grid_from_face_centroids(vertices, indices, cell_size) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(indices, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.spatial_grid_from_face_centroids(ptr0, len0, ptr1, len1, cell_size);
    return SpatialGrid.__wrap(ret);
}

/**
 * Build a grid that indexes raw vertex positions. For the sculpt brush.
 * @param {Float32Array} vertices
 * @param {number} cell_size
 * @returns {SpatialGrid}
 */
export function spatial_grid_from_vertices(vertices, cell_size) {
    const ptr0 = passArrayF32ToWasm0(vertices, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.spatial_grid_from_vertices(ptr0, len0, cell_size);
    return SpatialGrid.__wrap(ret);
}

/**
 * @param {Float32Array} points
 * @param {number} seg_idx
 * @returns {SubdivideResult}
 */
export function subdivide_curve_segment(points, seg_idx) {
    const ptr0 = passArrayF32ToWasm0(points, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.subdivide_curve_segment(ptr0, len0, seg_idx);
    return SubdivideResult.__wrap(ret);
}

/**
 * Main entry point. `offsets`/`corners` describe the polygon topology,
 * `poly_edges` + `edge_creases` carry the Hoppe piecewise-smooth creases.
 * Runs for `levels` iterations; both subdiv types refine every face of
 * size n into n quads, so the final mesh is all quads.
 * @param {Float32Array} positions
 * @param {Uint32Array} offsets
 * @param {Uint32Array} corners
 * @param {Float32Array} uvs
 * @param {Float32Array} morph_data
 * @param {number} morph_count
 * @param {Float32Array} skin_index
 * @param {Float32Array} skin_weight
 * @param {Float32Array} sculpt_displacement
 * @param {Uint32Array} poly_edges
 * @param {Float32Array} edge_creases
 * @param {number} subdiv_type
 * @param {number} levels
 * @returns {SubsurfResult}
 */
export function subsurf_core(positions, offsets, corners, uvs, morph_data, morph_count, skin_index, skin_weight, sculpt_displacement, poly_edges, edge_creases, subdiv_type, levels) {
    const ptr0 = passArrayF32ToWasm0(positions, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(offsets, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray32ToWasm0(corners, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ptr3 = passArrayF32ToWasm0(uvs, wasm.__wbindgen_malloc);
    const len3 = WASM_VECTOR_LEN;
    const ptr4 = passArrayF32ToWasm0(morph_data, wasm.__wbindgen_malloc);
    const len4 = WASM_VECTOR_LEN;
    const ptr5 = passArrayF32ToWasm0(skin_index, wasm.__wbindgen_malloc);
    const len5 = WASM_VECTOR_LEN;
    const ptr6 = passArrayF32ToWasm0(skin_weight, wasm.__wbindgen_malloc);
    const len6 = WASM_VECTOR_LEN;
    const ptr7 = passArrayF32ToWasm0(sculpt_displacement, wasm.__wbindgen_malloc);
    const len7 = WASM_VECTOR_LEN;
    const ptr8 = passArray32ToWasm0(poly_edges, wasm.__wbindgen_malloc);
    const len8 = WASM_VECTOR_LEN;
    const ptr9 = passArrayF32ToWasm0(edge_creases, wasm.__wbindgen_malloc);
    const len9 = WASM_VECTOR_LEN;
    const ret = wasm.subsurf_core(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, morph_count, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, ptr9, len9, subdiv_type, levels);
    return SubsurfResult.__wrap(ret);
}

function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_boolean_get_a86c216575a75c30: function(arg0) {
            const v = arg0;
            const ret = typeof(v) === 'boolean' ? v : undefined;
            return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_copy_to_typed_array_a4db337751e0b328: function(arg0, arg1, arg2) {
            new Uint8Array(arg2.buffer, arg2.byteOffset, arg2.byteLength).set(getArrayU8FromWasm0(arg0, arg1));
        },
        __wbg___wbindgen_throw_81fc77679af83bc6: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_call_368fa9c372d473ba: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            const ret = arg0.call(arg1, arg2, arg3);
            return ret;
        }, arguments); },
        __wbg_warn_982bee63bc2f9dfc: function(arg0, arg1) {
            console.warn(getStringFromWasm0(arg0, arg1));
        },
        __wbindgen_cast_0000000000000001: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./poseref_wasm_bg.js": import0,
    };
}

const AdjacencyResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_adjacencyresult_free(ptr >>> 0, 1));
const CurveEvalResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_curveevalresult_free(ptr >>> 0, 1));
const FaceGridFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_facegrid_free(ptr >>> 0, 1));
const FramesResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_framesresult_free(ptr >>> 0, 1));
const IKResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ikresult_free(ptr >>> 0, 1));
const InkingFeatureMapPackedFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_inkingfeaturemappacked_free(ptr >>> 0, 1));
const InkingPipelineResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_inkingpipelineresult_free(ptr >>> 0, 1));
const InkingStrokeGraphResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_inkingstrokegraphresult_free(ptr >>> 0, 1));
const LoopNormalsResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_loopnormalsresult_free(ptr >>> 0, 1));
const MeshExtractorResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_meshextractorresult_free(ptr >>> 0, 1));
const NormalsPartialResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_normalspartialresult_free(ptr >>> 0, 1));
const ProportionalWeightsResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_proportionalweightsresult_free(ptr >>> 0, 1));
const SettleResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_settleresult_free(ptr >>> 0, 1));
const SkinMeshResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_skinmeshresult_free(ptr >>> 0, 1));
const SpatialGridFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_spatialgrid_free(ptr >>> 0, 1));
const SubdivideResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_subdivideresult_free(ptr >>> 0, 1));
const SubsurfResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_subsurfresult_free(ptr >>> 0, 1));
const TopologyEdgesResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_topologyedgesresult_free(ptr >>> 0, 1));
const TopologyResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_topologyresult_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayF64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function getArrayI32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedFloat32ArrayMemory0 = null;
function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

let cachedFloat64ArrayMemory0 = null;
function getFloat64ArrayMemory0() {
    if (cachedFloat64ArrayMemory0 === null || cachedFloat64ArrayMemory0.byteLength === 0) {
        cachedFloat64ArrayMemory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64ArrayMemory0;
}

let cachedInt32ArrayMemory0 = null;
function getInt32ArrayMemory0() {
    if (cachedInt32ArrayMemory0 === null || cachedInt32ArrayMemory0.byteLength === 0) {
        cachedInt32ArrayMemory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint32ArrayMemory0 = null;
function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayF32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getFloat32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getFloat64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasm;
function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    wasmModule = module;
    cachedFloat32ArrayMemory0 = null;
    cachedFloat64ArrayMemory0 = null;
    cachedInt32ArrayMemory0 = null;
    cachedUint32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('poseref_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
